module.exports = "../img/wezimould-3rjorFG.svg";